import { render, staticRenderFns } from "./LockButton.vue?vue&type=template&id=12eca60e"
import script from "./LockButton.vue?vue&type=script&lang=js"
export * from "./LockButton.vue?vue&type=script&lang=js"
import style0 from "./LockButton.vue?vue&type=style&index=0&id=12eca60e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports